import React from "react";
import { Link } from "react-router-dom";

/**
 * Tabs component - sleek tab bar for navigation.
 * Supports link-based (href) or button-based (onChange) tabs.
 * @see .cursor/ui.md
 *
 * @param {Array} tabs - [{ value, label, href? }] - href for Link, else button
 * @param {string} value - Active tab value
 * @param {function} onChange - Callback when button tab is clicked
 */
const Tabs = ({ tabs = [], value, onChange, className = "" }) => {
  const renderUnderlineTab = (tab, isActive) => {
    const baseClasses =
      "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 focus:outline-none";
    const activeClasses = "border-primary text-primary";
    const inactiveClasses =
      "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300";

    const classes = `${baseClasses} ${
      isActive ? activeClasses : inactiveClasses
    }`;

    if (tab.href) {
      return (
        <Link key={tab.value} to={tab.href} className={classes}>
          {tab.label}
        </Link>
      );
    }

    return (
      <button
        key={tab.value}
        type="button"
        onClick={() => onChange?.(tab.value)}
        className={classes}
      >
        {tab.label}
      </button>
    );
  };

  return (
    <nav
      className={`w-full flex justify-start border-b border-gray-200 ${className}`}
      aria-label="Tabs"
    >
      <div className="flex space-x-8 -mb-px px-6">
        {tabs.map((tab) => {
          const isActive = value === (tab.href ?? tab.value);
          return renderUnderlineTab(tab, isActive);
        })}
      </div>
    </nav>
  );
};

export default Tabs;
